import { FormInstance } from 'antd';
import { useEffect, useState } from 'react';

import { AsnDTO } from '@invenco/supply-interface';

import { Form } from '@/components-ant/form';

import { Result } from '../../../../../../shared/helpers/Result';
import { ComponentData } from '../../../../../../shared/types';

type Models = {
  form: FormInstance;
  isSaving: boolean;
};

type Operations = {
  submit: (data: Record<string, any>) => Promise<void>;
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  updateAsn: (data: Partial<AsnDTO>) => Promise<Result>;
};

export function useExpectedDateModalComponent({
  isOpen,
  onClose,
  updateAsn,
}: Props): ComponentData<Models, Operations> {
  const [form] = Form.useForm();
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    form.resetFields();
  }, [isOpen, form]);

  const submit = async ({ expectedAt }: Record<string, any>) => {
    setIsSaving(true);
    const result = await updateAsn({
      expectedAt: expectedAt instanceof Date ? expectedAt.toISOString() : expectedAt,
    });
    setIsSaving(false);
    if (result.isSuccess) onClose();
  };

  return {
    models: { form, isSaving },
    operations: { submit },
  };
}
